import { Emit, Inject, Options, Prop, Vue, Watch } from "vue-property-decorator";
import { TrustAPI } from "@/shared/modules/trust-api";
import { AppInsights } from "@/trust-atcs-app/appInsights";
import store from "@/trust-atcs-app/store";
import { EventEmitter } from "events";
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import { EeReport, EeReportGeneralTrustMoney } from "@/shared/modules/typescript-trustapi-client/models";
import { FormEERData } from "@/trust-atcs-app/models/form-eer-data";
import RadioButtonHorizontal from "../questions/radiobutton-horizontal/index.vue";
import RadioButtonVertical from "../questions/radiobutton-vertical/index.vue";
import BankAccount from "../questions/bank-account/index.vue";
import { orderBy } from "lodash";
import RadioButtonSubQuestions from "../questions/radiobutton-subquestions/index.vue";
import { QuestionType } from "../questions/question-type";

@Options({
  components: {
    LoadingSpinner,
    RadioButtonHorizontal,
    RadioButtonVertical,
    BankAccount,
    RadioButtonSubQuestions,
  },
  mixins: [FormatDateTimeMixin],
})
export default class FormEerGeneralTrustMoney extends Vue {
  @Prop({ default: false })
  private isSectionLoading!: boolean;

  @Prop({ default: {} })
  private formEERData!: FormEERData;

  @Emit('update:isSectionLoading')

  @Emit('validForm')

  @Watch('loadingContent')
  private sectionLoading() {
    this.$emit('update:isSectionLoading', this.loadingContent);
  }

  private ai = new AppInsights;
  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private formType = 'EER';

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private loadingContent = false;
  private errorLoadingContent = false;

  private validMainQuestions: boolean[] = [];
  private generalTrustMoney: EeReportGeneralTrustMoney = null as any;

  mounted(): void {
    this.eventCtrl.on('reload-form-eer-gtm-content', this.loadGeneralTrustMoneyContent);
    // this.loadingContent = true;
    this.loadGeneralTrustMoneyContent();
    this.$emit('validForm', false);
  }

  beforeUnmount(): void {
    this.eventCtrl.removeListener('reload-form-eer-gtm-content', this.loadGeneralTrustMoneyContent);
  }

  private async loadGeneralTrustMoneyContent(): Promise<void> {
    try {
      this.loadingContent = true;
      const resp: any = await this.apiService.EeReportApi?.apiV2EeReportGetGeneralTrustMoneyPost({
        complianceFormId: this.complianceFormEER.id,
        updatingKey: this.updatingKey,
      });
      this.generalTrustMoney = resp.data.data as EeReportGeneralTrustMoney;

      this.generalTrustMoney.atcsMainQuestions.forEach((q: any) => {
        if (q.atcsQuestionTypeId == 19) {
          // Sort this.formEERData.generalTrustMoney.atcsMainQuestions[i].formPracticeAccountQuestions.atcsSubQuestions by order number
          q.formPracticeAccountQuestions.forEach((b: any) => {
            b.atcsSubQuestions = orderBy(b.atcsSubQuestions, ['order'], ['asc']);
          });
        }
      });

      this.formEERData.generalTrustMoney = this.generalTrustMoney as any;

      // Sort atcsMainQuestions by order number
      this.formEERData.generalTrustMoney.atcsMainQuestions = this.formEERData.generalTrustMoney.atcsMainQuestions.sort((a: any, b: any) => a.order - b.order);
      // Sort atcsSubQuestions by order number
      this.formEERData.generalTrustMoney.atcsMainQuestions.forEach((q: any) => {
        q.atcsSubQuestions = q.atcsSubQuestions.sort((a: any, b: any) => a.order - b.order);
      });
      // Sort response by order number
      this.formEERData.generalTrustMoney.atcsMainQuestions.forEach((q: any) => {
        q.responses = q.responses.sort((a: any, b: any) => a.order - b.order);
      });

      this.validMainQuestions = this.formEERData.generalTrustMoney.atcsMainQuestions.map((q: any) => false);
      // set atcsMainQuestions.questionTypeId == 1 to true
      this.formEERData.generalTrustMoney.atcsMainQuestions.forEach((q: any, i: number) => {
        if (q.atcsQuestionTypeId == 1) {
          this.validMainQuestions[i] = true;
        }
      });
      // add valid flag to each bank account
      this.formEERData.generalTrustMoney.atcsMainQuestions.forEach((q: any, i: number) => {

        if (q.atcsQuestionTypeId == 19) {
          this.formEERData.generalTrustMoney.atcsMainQuestions[i].formPracticeAccountQuestions =
            this.formEERData.generalTrustMoney.atcsMainQuestions[i].formPracticeAccountQuestions ?? [];
        }

        if (q.atcsQuestionTypeId == 20) {
          this.formEERData.generalTrustMoney.atcsMainQuestions[i].formPracticeSignatoryQuestions =
            this.formEERData.generalTrustMoney.atcsMainQuestions[i].formPracticeSignatoryQuestions ?? [];
        }

        // if (q.formPracticeAccountQuestions) {
        //   q.formPracticeAccountQuestions.forEach((b: any) => {
        //     b.valid = this.isValidBankAccount(b);
        //   });
        // }
      });
      // // add valid flag to each signatory
      // this.formEERData.generalTrustMoney.atcsMainQuestions.forEach((q: any) => {
      //   if (q.formPracticeSignatoryQuestions) {
      //     q.formPracticeSignatoryQuestions.forEach((s: any) => {
      //       s.valid = this.isValidSignatory(s);
      //     });
      //   }
      // });
    } catch (err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error getting General Trust Money');
      this.ai.trackException('Error getting General Trust Money: ' + err);
      this.errorLoadingContent = true;
      console.log(err);
    } finally {
      this.loadingContent = false;
    }
  }

  private validForm(): boolean {
    const allTrue = Object.values(this.validMainQuestions).every(value => value === true);
    return allTrue;
  }

  private validationForm(i: any, isValid: any) {
    this.validMainQuestions[i] = isValid;
    this.$emit('validForm', this.validForm());
  }

  get complianceFormEER(): EeReport {
    return store.getters.getSelectedComplianceFormEER;
  }

  get updatingKey(): string {
    return store.getters.getFormUpdatingKey;
  }

  get QuestionType(): any {
    return QuestionType;
  }

}

